import styled from '@emotion/styled'

import { colors, palette, spacing, Text, typography } from 'main/ui'

export const height = 50
export const margin = spacing.majorScale(3)

export const Container = styled.div`
  display: flex;
  flex-direction: row;
`

export const ButtonContainer = styled.div`
  background-color: ${palette.white};
  border-radius: ${spacing.majorScale(3)}px;
  box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.25);
  width: 50%;
  height: ${height}px;
  position: fixed;
  bottom: ${margin}px;
  left: 25%;
`

interface IButtonProps {
  active: boolean
}

const ButtonBase = styled.button<IButtonProps>`
  background-color: ${props => (props.active ? palette.whiteDove : palette.white)};
  border: 1px solid rgba(0, 0, 0, 0.06);
  width: 50%;
  height: 100%;
  outline: none;
`

export const ButtonText = styled(Text)<IButtonProps>`
  color: ${props => (props.active ? palette.black : palette.skyBlue2)};
  font-weight: ${props =>
    props.active ? typography.fontWeight.bold : typography.fontWeight.regular};
`

export const ListButton = styled(ButtonBase)`
  border-right: 1px solid ${colors.border.default};
  border-top-left-radius: inherit;
  border-bottom-left-radius: inherit;
`

export const MapButton = styled(ButtonBase)`
  border-top-right-radius: inherit;
  border-bottom-right-radius: inherit;
`
